export class AdminUsersApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** List platform accounts for the operator's scope, filtered by realm/status/search (S-console oversight). */
    list(query = {}) {
        // D413 (W5S-09 b): `POST /v1/ops/users/search` with every filter in the BODY — a phone or an email searched never
        // travels in a URL. A contact search (phones/emails matched, `account:manage`) is recorded on the directory
        // access log but spends no lookup budget (owner decision on review W7S-02). (`GET /v1/ops/users` refuses `q`.)
        const body = {
            ...(query.realm !== undefined ? { realm: query.realm } : {}),
            ...(query.status !== undefined ? { status: query.status } : {}),
            ...(query.country !== undefined ? { country: query.country } : {}),
            ...(query.city !== undefined ? { city: query.city } : {}),
            ...(query.search !== undefined && query.search !== '' ? { q: query.search } : {}),
            ...(query.limit !== undefined ? { limit: query.limit } : {}),
            ...(query.offset !== undefined ? { offset: query.offset } : {}),
        };
        return this.client.request({ method: 'POST', path: '/v1/ops/users/search', body, auth: true });
    }
    /** One account's directory record by id (the person page). Scope-checked server-side against the account's country. */
    get(userId) {
        return this.client.request({ method: 'GET', path: `/v1/ops/users/${encodeURIComponent(userId)}`, auth: true });
    }
    /** Suspend or reactivate an account (operator `account:manage`; scope-checked + audited server-side). */
    setStatus(userId, status, reason) {
        return this.client.request({ method: 'POST', path: `/v1/ops/users/${encodeURIComponent(userId)}/status`, body: { status, ...(reason !== undefined && reason !== '' ? { reason } : {}) }, auth: true });
    }
    /** Edit an account's mutable profile fields (operator `account:manage`; validated + audited server-side). */
    update(userId, patch) {
        return this.client.request({ method: 'PATCH', path: `/v1/ops/users/${encodeURIComponent(userId)}`, body: patch, auth: true });
    }
    /** The append-only account-action history for one account, newest first (operator `account:manage`). */
    /**
     * Reveal an account's whole contact (operator `account:manage` at the account's country). The server records the reveal
     * in the account's append-only audit BEFORE it answers; a reveal it cannot record is refused (503).
     */
    revealContact(userId) {
        return this.client.request({ method: 'POST', path: `/v1/ops/users/${encodeURIComponent(userId)}/contact-reveal`, auth: true });
    }
    /**
     * D619: the names behind up to 200 account ids (operator `account:view` at each account's country; the others are left
     * out). Names only — never a contact.
     */
    names(ids) {
        return this.client.request({ method: 'POST', path: '/v1/ops/users/names', body: { ids }, auth: true });
    }
    audit(userId) {
        return this.client.request({ method: 'GET', path: `/v1/ops/users/${encodeURIComponent(userId)}/audit`, auth: true });
    }
}
//# sourceMappingURL=admin-users.js.map